// src/plugins/toast.js

import Vue from "vue";
import Toast from "../components/cards/VueToast.vue";

const toast = {
  install(Vue) {
    const ToastConstructor = Vue.extend(Toast);
    const toastInstance = new ToastConstructor();

    toastInstance.$mount(document.createElement("div"));
    document.body.appendChild(toastInstance.$el);

    Vue.prototype.$toast = {
      success(message) {
        toastInstance.showToast(message, "success");
      },
      error(message) {
        toastInstance.showToast(message, "error");
      },
      warning(message) {
        toastInstance.showToast(message, "warning");
      },
      info(message) {
        toastInstance.showToast(message, "info");
      },
      primary(message) {
        toastInstance.showToast(message, "primary");
      },
    };
  },
};

export default toast;
